export default {
    fields: [
        // 基本信息
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            id: "baoliqiuji00000001308",
            inputLength: 111,
            keyword: "name",
            name: "姓名",
            nameEn: 'Name',
            placeholder: "请输入您的姓名",
            placeholderEn: 'Name',
            required: true,
            step: 1,
            subjectType: "VISITOR",
        },
        {
            canSelect: true,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji0000000137",
            inputLength: null,
            keyword: "countryName",
            name: "国家",
            nameEn: 'Nationality',
            placeholder: "请选择",
            placeholderEn: 'Nationality',
            required: true,
            showType: "perfectInformation",
            step: 1,
            subjectType: "VISITOR",
        },
        {
            canSelect: true,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji00000001281",
            inputLength: null,
            keyword: "provinceName",
            name: "省份",
            nameEn: 'Province',
            placeholder: "请选择",
            placeholderEn: 'Please select',
            required: true,
            showType: "perfectInformation",
            step: 1,
            subjectType: "VISITOR"
        },
        {
            canSelect: true,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji00000001155",
            inputLength: null,
            keyword: "cityName",
            name: "城市",
            nameEn: 'City',
            placeholder: "请选择",
            placeholderEn: 'Please select',
            required: true,
            showType: "perfectInformation",
            step: 1,
            subjectType: "VISITOR",
        },
        // {
        //     canSelect: true,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji00000001101",
        //     inputLength: 100,
        //     keyword: "idType",
        //     name: "证件类型",
        //     nameEn: 'ID Document Type',
        //     placeholder: "证件类型",
        //     placeholderEn: "ID Document Type",
        //     required: true,
        //     showType: "perfectInformation",
        //     step: 1,
        //     subjectType: "VISITOR",
        // },
        // {
        //     canSelect: false,
        //     editable: true,
        //     height: 0,
        //     inputLength: null,
        //     keyword: "post",
        //     name: "职位",
        //     nameEn: "Postion",
        //     placeholder: "职务",
        //     placeholderEn: "Postion",
        //     required: true,
        //     showType: "perfectInformation",
        //     step: 1,
        //     subjectType: "VISITOR",
        // },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji0000000139",
            inputLength: null,
            keyword: "email",
            name: "邮箱",
            nameEn: "E-mail",
            placeholder: "邮箱",
            placeholderEn: "E-mail",
            required: true,
            showType: "perfectInformation",
            step: 1,
            subjectType: "VISITOR",
        },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001317",
            inputLength: 11,
            keyword: "mobile",
            name: "手机",
            nameEn: "Mobile",
            placeholder: "手机号码",
            placeholderEn: "Mobile",
            required: false,
            showType: "perfectInformation",
            step: 1,
            subjectType: "VISITOR",
        },
        // {
        //     canSelect: true,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 0,
        //     id: "baoliqiuji000000013766",
        //     inputLength: null,
        //     keyword: "socialMedia",
        //     name: "社交媒体",
        //     nameEn: "Soclal media you use most frequently",
        //     placeholder: "社交媒体",
        //     placeholderEn: "Soclal media you use most frequently",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 1,
        //     subjectType: "VISITOR",
        // },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 0,
        //     id: "baoliqiuji00000001301",
        //     inputLength: null,
        //     keyword: "headImage",
        //     name: "头像",
        //     nameEn: "Photo",
        //     placeholder: "头像",
        //     placeholderEn: "Photo",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001141",
            inputLength: 100,
            keyword: "workPass",
            name: "工作证",
            nameEn: "Work Pass",
            placeholder: "",
            placeholderEn: "Work Pass",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR"
        },
        // 公司信息
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji00000001390",
            inputLength: null,
            keyword: "corporateName",
            name: "公司名称",
            nameEn: "Company Name",
            placeholder: "请输入您的公司名称",
            placeholderEn: "Company Name",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR",
        },
        {
            canSelect: true,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji000000013755",
            inputLength: null,
            keyword: "corporateCountryName",
            name: "公司所在国",
            nameEn: "Company Country/Region",
            placeholder: "公司所在国",
            placeholderEn: "Company Country/Region",
            required: true,
            showType: "perfectInformation",
            step: 1,
            subjectType: "VISITOR",
        },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji0000000186",
        //     inputLength: 100,
        //     keyword: "brand",
        //     name: "品牌",
        //     nameEn: "Brand",
        //     placeholder: "品牌",
        //     placeholderEn: "Brand",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji0000000193",
        //     inputLength: 100,
        //     keyword: "website",
        //     name: "公司网址",
        //     nameEn: "Company Website",
        //     placeholder: "公司网址",
        //     placeholderEn: "Company Website",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji00000001212",
            inputLength: null,
            keyword: "address",
            name: "公司地址",
            nameEn: "Company Address",
            placeholder: "请输入您的公司地址",
            placeholderEn: "Company Address",
            required: false,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR"
        },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji00000001279",
            inputLength: null,
            keyword: "telephone",
            name: "公司电话",
            nameEn: "Company Tel",
            placeholder: "公司电话",
            placeholderEn: "Company Tel",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR",
        },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji0000000197",
        //     inputLength: 100,
        //     keyword: "fax",
        //     name: "公司传真",
        //     nameEn: "Company Fax",
        //     placeholder: "公司传真",
        //     placeholderEn: "Company Fax",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001113",
            inputLength: 100,
            keyword: "registration",
            name: "登记证（外国（地区）常驻代表机构登记证）",
            nameEn: "Registration Certificate",
            placeholder: "",
            placeholderEn: "Registration Certificate",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR"
        },
        // 公司总部信息
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001117",
            inputLength: 100,
            keyword: "nameHeadQuater",
            name: "总部公司名",
            nameEn: "Name of Head Quater",
            placeholder: "总部公司名",
            placeholderEn: "Name of Head Quater",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR",
        },
        {
            canSelect: true,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001109",
            inputLength: 100,
            keyword: "countryHeadQuater",
            name: "总部国家",
            nameEn: "Country of Head Quater",
            placeholder: "总部国家",
            placeholderEn: "Country of Head Quater",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR"
        },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001121",
            inputLength: 100,
            keyword: "addressHeadQuater",
            name: "总部地址",
            nameEn: "Address of Head Quater",
            placeholder: "总部地址",
            placeholderEn: "Address of Head Quater",
            required: false,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR"
        },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001125",
            inputLength: 100,
            keyword: "telephoneHeadQuater",
            name: "总部电话",
            nameEn: "Telephone",
            placeholder: "总部电话",
            placeholderEn: "Telephone",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR",
        },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji00000001129",
        //     inputLength: 100,
        //     keyword: "faxHeadQuater",
        //     name: "总部传真",
        //     nameEn: "Fax",
        //     placeholder: "总部传真",
        //     placeholderEn: "Fax",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001133",
            inputLength: 100,
            keyword: "emailHeadQuater",
            name: "总部邮箱",
            nameEn: "E-mail",
            placeholder: "总部邮箱",
            placeholderEn: "E-mail",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR"
        },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001137",
            inputLength: 100,
            keyword: "websiteHeadQuater",
            name: "总部网址",
            nameEn: "Website",
            placeholder: "总部网站",
            placeholderEn: "Website",
            required: false,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR"
        }
    ]
}